import { createContext, useContext } from "react";
import { DatabaseService } from "@service/DatabaseService";

export const DatabaseContext = createContext<DatabaseService | undefined>(undefined);

export function useDatabaseContext() {
    const context = useContext(DatabaseContext);
    if (context == null) {
        throw new Error("Missing DatabaseContext.");
    }
    return context;
}
